import { InfoItemButton as L2rInfoItemButton, styled, Skeleton, Typography } from "@l2r-front/l2r-ui"

export const RoadInfoItem = styled(L2rInfoItemButton)({
    "& > span": {
        textTransform: "capitalize !important",
    },
    height: "auto",
    minHeight: 46,
})

export const RoadInfoItemSkeleton = styled(Skeleton)({
    height: 46,
})

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
}))